/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
Swiper.use([Navigation]);
export function slider() {
    const imageSliderSelector = ".image-slider__inner.swiper"

    //Fix the tabindex for accebility if the content of the slide is wrapped in an anchor tag
    const handleSlideChangeTransitionEnd = function (swiper) {
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
    const handleSlideChange = function () {
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const init = function () {

        // Image Slider
        const imageSlider = [];
        const imageSliderElements = document.querySelectorAll(imageSliderSelector);
        if (imageSliderElements) {
            imageSliderElements.forEach(slider => {
                imageSlider.push(new Swiper(slider, {
                    slidesPerView: 1.5,
                    spaceBetween: 10,
                    speed: 600,
                    slidesOffsetAfter: 15,
                    breakpoints: {
                        768: {
                            spaceBetween: 30,
                            slidesPerView: 2.3,
                            slidesOffsetAfter:30
                        }
                    },
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .image-slider__button-next",
                        prevEl: '#' + slider.dataset.componentId + " .image-slider__button-prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }
    };

    init();
}
